import svgIcons from '@/assets/svg/icons';
import SvgIcon from '@/components/atoms/SvgIcon';
import CircleFillOutWithText from '@/components/molecules/WellnessStateCircle/CircleFillOutWithText';
import { WELLNESS_DATA_MULTIPLIER, WELLNESS_SUB_DOMAINS_DISPLAY_LABELS } from '@/constants';
import { background, primary, text } from '@/theme/colors/palettes';
import { TSubdomainConcern } from '@/types/Health.types';
import { ceilOrFloor } from '@/utils/number';
import { HStack, Text, VStack } from '@chakra-ui/react';
import React from 'react';

const SubdomainInfoInterpretation = ({
  subdomainConcern,
  onClickSubdomain,
}: {
  subdomainConcern: TSubdomainConcern;
  onClickSubdomain: () => void;
}) => {
  const score = ceilOrFloor(subdomainConcern.score * WELLNESS_DATA_MULTIPLIER);

  const isOther = subdomainConcern.subdomain.startsWith('OTHER');
  const otherAnswer = subdomainConcern.questions?.[0].value;

  return (
    <VStack
      backgroundColor={background.lightPurple}
      padding={4}
      gap={1.5}
      rounded={10}
      width={'100%'}
      cursor={'pointer'}
      onClick={onClickSubdomain}
    >
      <HStack width={'100%'} justify={'space-between'} alignItems={'center'}>
        <Text variant={'urbanistBoldLarge'} width={'80%'} color={primary[500]} noOfLines={2} textAlign={'start'}>
          {WELLNESS_SUB_DOMAINS_DISPLAY_LABELS[subdomainConcern.subdomain]}
        </Text>
        {!isOther && (
          <HStack alignItems={'center'} gap={3}>
            <CircleFillOutWithText
              svgId={`${subdomainConcern.subdomain}-subdomain-circle`}
              showPercentageText={false}
              percentageFilled={score}
              circleDiameter={20}
              thickness={4}
            />
            <Text variant={'urbanistBold'} width={'80%'} color={text.mediumBlue}>
              {score}/100
            </Text>
          </HStack>
        )}
      </HStack>
      <HStack justifyContent={'space-between'} width="100%" alignItems={'center'}>
        {isOther ? (
          <VStack align={'start'} gap={0}>
            <Text variant={'urbanistMedium'} noOfLines={4} color={text.mediumGray} marginRight={4} width={'85%'}>
              {subdomainConcern.interpretation.substring(0, subdomainConcern.interpretation.length - 1)}:{' '}
            </Text>
            <Text variant={'urbanistSemiBold'} color={text.mediumBlue} marginTop={'8px'} textAlign={'start'}>
              {otherAnswer}
            </Text>
          </VStack>
        ) : (
          <Text
            variant={'urbanistSemiBold'}
            noOfLines={4}
            color={text.mediumGray}
            marginRight={4}
            width={'85%'}
            textAlign={'start'}
          >
            {subdomainConcern.interpretation}
          </Text>
        )}

        <VStack>
          <SvgIcon iconPath={svgIcons.rightArrow} color={primary[500]} size={20} />
        </VStack>
      </HStack>
    </VStack>
  );
};

export default SubdomainInfoInterpretation;
